import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { API_BASE } from '../../config/api';
import { FaArrowRight } from 'react-icons/fa';
import './AdminAboutEdit.css';

const DEFAULT_FORM = {
  header_title: 'من أنا؟ ولماذا هذا الموقع؟',
  header_subtitle: 'رحلة من التشتت في لندن... إلى التمكين الأكاديمي.',
  lead_text: '',
  timeline1_text: '',
  timeline2_text: '',
  turning_intro_text: '',
  dialogue_text: '',
  turning_outro_text: '',
  vow_quote: 'ولا طالبة لازم تمر باللي مريت فيه.',
  vow_text: 'وهنا بدأ هذا الموقع.',
  mission_image_url:
    'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1000&auto=format&fit=crop',
  mission_desc1: '',
  mission_desc2: '',
  benefit1_text: '',
  benefit2_text: '',
  benefit3_text: '',
  cta_title: 'جاهزة لتبدئي رحلة بحثية واثقة؟',
  cta_button_text: 'احجزي استشارتك الآن',
  cta_button_link: '/booking',
};

const AdminAboutEdit = () => {
  const navigate = useNavigate();

  const getAuthHeaders = () => {
    const token = localStorage.getItem('adminToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(DEFAULT_FORM);

  const empty = useMemo(() => DEFAULT_FORM, []);

  useEffect(() => {
    axios
      .get(`${API_BASE}/api/admin/about`, { headers: getAuthHeaders() })
      .then((res) => {
        const a = res.data?.about;
        if (!a) return setForm(empty);
        setForm({ ...empty, ...a });
      })
      .catch((err) => {
        console.error('Failed to load about:', err);
        setForm(empty);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API_BASE}/api/admin/about`, form, {
        headers: getAuthHeaders(),
      });
      alert('تم حفظ صفحة من أنا بنجاح');
      navigate('/admin');
    } catch (err) {
      alert(err.response?.data?.error || 'فشل حفظ الصفحة');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="admin-loading">جاري التحميل...</div>;

  return (
    <div className="admin-about-edit" dir="rtl">
      <div className="admin-about-edit-header">
        <Link to="/admin" className="back-link">
          <FaArrowRight /> العودة للصفحة الرئيسية
        </Link>
        <h1 className="admin-page-title">تعديل صفحة من أنا</h1>
      </div>

      <form onSubmit={handleSubmit} className="admin-about-form">
        <div className="form-row">
          <label>عنوان الهيدر</label>
          <input
            className="form-input"
            value={form.header_title}
            onChange={(e) => handleChange('header_title', e.target.value)}
          />
        </div>
        <div className="form-row">
          <label>وصف الهيدر</label>
          <input
            className="form-input"
            value={form.header_subtitle}
            onChange={(e) => handleChange('header_subtitle', e.target.value)}
          />
        </div>

        <div className="form-row">
          <label>النص الافتتاحي</label>
          <textarea
            className="form-input"
            rows={5}
            value={form.lead_text}
            onChange={(e) => handleChange('lead_text', e.target.value)}
          />
        </div>

        <div className="form-row">
          <label>Timeline 1</label>
          <textarea
            className="form-input"
            rows={5}
            value={form.timeline1_text}
            onChange={(e) => handleChange('timeline1_text', e.target.value)}
          />
        </div>
        <div className="form-row">
          <label>Timeline 2</label>
          <textarea
            className="form-input"
            rows={5}
            value={form.timeline2_text}
            onChange={(e) => handleChange('timeline2_text', e.target.value)}
          />
        </div>

        <div className="form-row">
          <label>Turning point intro</label>
          <textarea
            className="form-input"
            rows={3}
            value={form.turning_intro_text}
            onChange={(e) => handleChange('turning_intro_text', e.target.value)}
          />
        </div>
        <div className="form-row">
          <label>النص داخل الصندوق (Dialogue)</label>
          <textarea
            className="form-input"
            rows={2}
            value={form.dialogue_text}
            onChange={(e) => handleChange('dialogue_text', e.target.value)}
          />
        </div>
        <div className="form-row">
          <label>Turning point outro</label>
          <textarea
            className="form-input"
            rows={5}
            value={form.turning_outro_text}
            onChange={(e) => handleChange('turning_outro_text', e.target.value)}
          />
        </div>

        <div className="form-row">
          <label>نص الوعد (Quote)</label>
          <input
            className="form-input"
            value={form.vow_quote}
            onChange={(e) => handleChange('vow_quote', e.target.value)}
          />
        </div>
        <div className="form-row">
          <label>نص الوعد (سطر تحت)</label>
          <input
            className="form-input"
            value={form.vow_text}
            onChange={(e) => handleChange('vow_text', e.target.value)}
          />
        </div>

        <div className="form-row">
          <label>رابط صورة المهمة</label>
          <input
            className="form-input"
            value={form.mission_image_url}
            onChange={(e) => handleChange('mission_image_url', e.target.value)}
            placeholder="https://..."
          />
        </div>

        <div className="form-row">
          <label>وصف المهمة 1</label>
          <textarea
            className="form-input"
            rows={4}
            value={form.mission_desc1}
            onChange={(e) => handleChange('mission_desc1', e.target.value)}
          />
        </div>
        <div className="form-row">
          <label>وصف المهمة 2</label>
          <textarea
            className="form-input"
            rows={4}
            value={form.mission_desc2}
            onChange={(e) => handleChange('mission_desc2', e.target.value)}
          />
        </div>

        <div className="form-row">
          <label>Benefit 1</label>
          <textarea
            className="form-input"
            rows={4}
            value={form.benefit1_text}
            onChange={(e) => handleChange('benefit1_text', e.target.value)}
          />
        </div>
        <div className="form-row">
          <label>Benefit 2</label>
          <textarea
            className="form-input"
            rows={3}
            value={form.benefit2_text}
            onChange={(e) => handleChange('benefit2_text', e.target.value)}
          />
        </div>
        <div className="form-row">
          <label>Benefit 3</label>
          <textarea
            className="form-input"
            rows={4}
            value={form.benefit3_text}
            onChange={(e) => handleChange('benefit3_text', e.target.value)}
          />
        </div>

        <div className="form-row">
          <label>CTA Title</label>
          <input
            className="form-input"
            value={form.cta_title}
            onChange={(e) => handleChange('cta_title', e.target.value)}
          />
        </div>
        <div className="form-row inline-row">
          <div>
            <label>CTA Button text</label>
            <input
              className="form-input short"
              value={form.cta_button_text}
              onChange={(e) => handleChange('cta_button_text', e.target.value)}
            />
          </div>
          <div>
            <label>CTA Button link</label>
            <input
              className="form-input short"
              value={form.cta_button_link}
              onChange={(e) => handleChange('cta_button_link', e.target.value)}
              placeholder="/booking"
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="admin-btn-primary" disabled={saving}>
            {saving ? 'جاري الحفظ...' : 'حفظ'}
          </button>
          <button
            type="button"
            className="admin-btn-secondary"
            onClick={() => navigate('/admin')}
            disabled={saving}
          >
            إلغاء
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminAboutEdit;

